import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

import {
  fetchMedicalConditions,
  setClinicalServiceSteps,
  updateClinicalService,
} from "../../../../../redux/modules/clinical-services/actions";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import Steps from "../../Steps";
import NewToolTip from "../../../../common/New-ToolTip";
import EndServiceModel from "../../../../common/EndServiceModel";
import OtitisCond from "../../../../common/tooltip/minor-ailments/otitis-cond";
import RecurrentCond from "../../../../common/tooltip/minor-ailments/recurrent-cont";
import { AlertConfirmationTypes } from "../../../../../helpers/constant";
import { acuteMCEnum, chronicMCEnum } from "./data";
import MedicalConditionCreate from "./MedicalConditionCreate";
import MedicalConditionAlert from "./MedicalConditionAlert";
import Button from "../../../../common/Button";
import SubNavigation from "../../common/sub-navigation";
import { calculateAgeYear } from "../../../../../helpers/functions";
import { getValidStep, updateStepsValidity } from "../../../text/data";

const RedFlag = () => {
  const {
    clinicalServiceObj,
    clinicalServiceSteps,
    medicalConditions: condition,
  } = useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);
  const { medicalConditions } = condition;
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { id: patientId, serviceId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isAcuteCreation, setIsAcuteCreation] = useState(false);
  const [acuteMCVals, setAcuteMCVals] = useState([]);
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);
  const [chronicMCVals, setChronicMCVals] = useState([]);
  const [asthmaSymptomControl, setAsthmaSymptomControl] = useState(null);
  const [thyroidSymptomControl, setThyroidSymptomControl] = useState(null);
  const [RedFlagCard, setRedFlagCard] = useState(1);
  const [isAcuteMCUpdate, setIsAcuteMCUpdate] = useState(false);
  const [actureReVisit, setAcuteReVisit] = useState(false);
  const [isChronicMCUpdate, setIsChronicMCUpdate] = useState(false);
  const [chronicReVisit, setChronicReVisit] = useState(false);
  const [completeSubStep, setCompleteSubStep] = useState(false);
  const [clinicalAnalysis, setClinicalAnalysis] = useState(false);
  const [redFlagObj, setRedFlagObj] = useState(null);

  const [showOtitisTooltip, setShowOtitisTooltip] = useState(false);
  //Red Flag Alerts
  const [openNoMCDialog, setOpenNoMCDialog] = useState(false);
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  // const [noMedCondition, setNoMedCondition] = useState(false);
  const [openMultiConditionDialog, setOpenMultiConditionDialog] =
    useState(false);
  const [continueService, setContinueService] = useState(false);
  const [openMCAlertDialog, setOpenMCAlertDialog] = useState(false);
  const [reAssessConditions, setReAssessConditions] = useState([]);
  //Red Flag Alert Input
  const [alterContent, setAlterContent] = useState("");

  //Red Flag Models
  const [showMCCreateSlider, setShowMCCreateSlider] = useState(false);
  const [needToOpenMCCreateAfterAlert, setNeedToOpenMCCreateAfterAlert] =
    useState(false);
  //Red Flag Model Inputs
  const [medicationStepCount, setMedicationStepCount] = useState(null);
  const [selectedMedicalCondition, setSelectedMedicalCondition] = useState();
  const [clickedEndService, setClickedEndService] = useState(false);
  const [alertConfirmation, setAlertConfirmation] = useState(0);
  const [alertExplaination, setAlertExplaination] = useState("");
  const sliderTransitionTimeoutRef = useRef(null);
  const sliderTransitionMs = 450;

  useEffect(() => {
    return () => {
      if (sliderTransitionTimeoutRef.current) {
        clearTimeout(sliderTransitionTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (clickedEndService) {
      onNext();
      setClickedEndService(false);
    }
  }, [clinicalServiceSteps, clickedEndService]);

  //state management
  useEffect(() => {
    dispatch(fetchMedicalConditions(patientId));
  }, []);

  useEffect(() => {
    if (
      clinicalServiceObj.initialAssessment.initialAssessmentForm !==
        undefined &&
      clinicalServiceObj.initialAssessment.initialAssessmentForm
        .clinicalAssessment !== null &&
      (clinicalServiceObj.initialAssessment.initialAssessmentForm
        ?.clinicalAssessment.acuteMedicalConditions !== null ||
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment?.chronicMedicalConditions !== null)
    ) {
      setChronicMCVals(
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment?.chronicMedicalConditions?.length > 0
          ? clinicalServiceObj.initialAssessment.initialAssessmentForm?.clinicalAssessment?.chronicMedicalConditions.map(
              (x) => x.medicalConditionName
            )
          : ["None"]
      );
      setThyroidSymptomControl(
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment?.chronicMedicalConditions?.length > 0
          ? clinicalServiceObj.initialAssessment.initialAssessmentForm?.clinicalAssessment?.chronicMedicalConditions.filter(
              (x) => x.medicalConditionName === "hypothyroidism"
            )[0]?.symptomControlIndicator
          : false
      );
      setAsthmaSymptomControl(
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment?.chronicMedicalConditions?.length > 0
          ? clinicalServiceObj.initialAssessment.initialAssessmentForm?.clinicalAssessment?.chronicMedicalConditions.filter(
              (x) => x.medicalConditionName === "asthma"
            )[0]?.symptomControlIndicator
          : false
      );
      setAcuteMCVals(
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment.acuteMedicalConditions?.length > 0
          ? clinicalServiceObj.initialAssessment.initialAssessmentForm
              ?.clinicalAssessment.acuteMedicalConditions
          : ["None"]
      );
      setRedFlagCard(3);
      setClinicalAnalysis(true);
      setCompleteSubStep(true);
    }
  }, [clinicalServiceObj]);

  useEffect(() => {
    if (redFlagObj !== null) {
      if (
        RedFlagCard === 1 &&
        redFlagObj.acuteMCVals !== undefined &&
        redFlagObj.acuteMCVals.length > 0
      ) {
        setAcuteReVisit(true);
      } else if (
        RedFlagCard === 2 &&
        redFlagObj.chronicMCVals !== undefined &&
        redFlagObj.chronicMCVals.length > 0
      ) {
        setChronicReVisit(true);
      }
    }
  }, [RedFlagCard]);

  const updateStepsVisibility = async (disable = false) => {
    const updatedServiceSteps = updateStepsValidity(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      disable
    );
    await dispatch(setClinicalServiceSteps(updatedServiceSteps));
  };

  const updateSelectedCondition = (condName) => {
    if (chronicMCEnum.options.some((x) => x.value === condName)) {
      var cond = chronicMCEnum.options.find((x) => x.value === condName);
      setSelectedMedicalCondition(cond);
    } else if (acuteMCEnum.options.some((x) => x.value === condName)) {
      var cond = acuteMCEnum.options.find((x) => x.value === condName);
      setSelectedMedicalCondition(cond);
    }
  };

  const onNext = () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(
        clinicalServiceSteps,
        currentStep,
        currentSubStep,
        1
      );

      let updatedSteps = {};
      // if (isContinueClicked) {
      //   updatedSteps = {
      //     currentStep: nextStep,
      //     currentSubStep: nextSubStep,
      //   };
      // } else {
      const chronicArray = [];
      if (chronicMCVals.includes("asthma"))
        chronicArray.push({
          medicalConditionName: "asthma",
          symptomControlIndicator: asthmaSymptomControl,
        });
      if (chronicMCVals.includes("hypothyroidism"))
        chronicArray.push({
          medicalConditionName: "hypothyroidism",
          symptomControlIndicator: thyroidSymptomControl,
        });
      updatedSteps = {
        clinicalAssessment: {
          chronicMedicalConditions: chronicArray,
          acuteMedicalConditions: acuteMCVals == ["None"] ? [] : acuteMCVals,
          redFlagConfirmationType: alertConfirmation,
          redFlagExplaination: alertExplaination,
        },
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        showReferral: showRef,
        serviceSteps: clinicalServiceSteps,
      };
      // }
      dispatch(updateClinicalService(serviceId, updatedSteps));
    }
  };

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep };
    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  const acuteMultiSelection = (val) => {
    if (actureReVisit === true) setIsAcuteMCUpdate(true);
    if (val === "None") {
      !acuteMCVals.includes(val)
        ? setAcuteMCVals(["None"])
        : setAcuteMCVals([]);
    } else {
      if (acuteMCVals.includes("None")) {
        setAcuteMCVals([val]);
      } else {
        acuteMCVals.includes(val)
          ? setAcuteMCVals(acuteMCVals.filter((item) => item !== val))
          : setAcuteMCVals([...acuteMCVals, val]);
      }
    }
  };

  const chronicMultiSelection = (val) => {
    if (chronicReVisit === true) setIsChronicMCUpdate(true);

    if (val === "None") {
      !chronicMCVals.includes(val)
        ? setChronicMCVals(["None"])
        : setChronicMCVals([]);
    } else {
      if (chronicMCVals.includes("None")) {
        setChronicMCVals([val]);
      } else {
        chronicMCVals.includes(val)
          ? setChronicMCVals(chronicMCVals.filter((item) => item !== val))
          : setChronicMCVals([...chronicMCVals, val]);
      }
    }
  };

  const handleAcute = () => {
    if (
      acuteMCVals.includes("otitis media") &&
      acuteMCVals.includes("sinusitis")
    ) {
      updateSelectedCondition("sinusitis");
      setMedicationStepCount(1);
      setIsAcuteCreation(true);
      setShowMCCreateSlider(true);
    } else if (acuteMCVals.includes("otitis media")) {
      setMedicationStepCount(null);
      updateSelectedCondition("otitis media");

      const isSinusitisExist = medicalConditions.some(
        (val) =>
          val.status === "active" && val.conditionName.includes("sinusitis")
      );
      if (isSinusitisExist) {
        // filtering out options to show in alert pop-up
        const filterConditions = medicalConditions.filter((c) =>
          acuteMCEnum.options.some(
            (o) =>
              !o.value.includes("otitis media") &&
              o.value.toLowerCase() === c.conditionName.toLowerCase()
          )
        );
        if (filterConditions.length > 0) {
          setReAssessConditions(filterConditions);
          setOpenMCAlertDialog(true);
          setNeedToOpenMCCreateAfterAlert(true);
        }
      } else {
        // setting field to open create slider
        setMedicationStepCount(null);
        updateSelectedCondition("otitis media");
        setIsAcuteCreation(true);
        setShowMCCreateSlider(true);
      }
    } else if (acuteMCVals.includes("sinusitis")) {
      setMedicationStepCount(null);
      updateSelectedCondition("sinusitis");

      // checking for Otitis Media, If present then show alert first and then create slider for Asthma
      const isOtitisMediaExist = medicalConditions.some(
        (val) =>
          val.status === "active" && val.conditionName.includes("otitis media")
      );
      if (isOtitisMediaExist) {
        // filtering out options to show in alert pop-up
        const filterConditions = medicalConditions.filter((c) =>
          acuteMCEnum.options.some(
            (o) =>
              !o.value.includes("sinusitis") &&
              o.value.toLowerCase() === c.conditionName.toLowerCase()
          )
        );
        if (filterConditions.length > 0) {
          setReAssessConditions(filterConditions);
          setOpenMCAlertDialog(true);
          setNeedToOpenMCCreateAfterAlert(true);
        }
      } else {
        // setting field to open create slider
        setMedicationStepCount(null);
        updateSelectedCondition("sinusitis");
        setIsAcuteCreation(true);
        setShowMCCreateSlider(true);
      }
    } else {
      // for none, we're checking current medical condition and passing only those which are active for current patient
      const filterConditions = medicalConditions.filter(
        (c) =>
          c.status === "active" &&
          acuteMCEnum.options.some(
            (o) => o.value.toLowerCase() === c.conditionName.toLowerCase()
          )
      );
      if (filterConditions.length > 0) {
        setReAssessConditions(filterConditions);
        setOpenMCAlertDialog(true);
      } else setRedFlagCard(2);
    }
  };

  const getSortedConditions = () => {
    const isAcute =
      reAssessConditions.findIndex((val) =>
        acuteMCEnum.options.map((l) => l.value).includes(val.conditionName)
      ) >= 0;
    const conditionsToReturn = [];
    if (isAcute) {
      const sinusitisIndex = reAssessConditions.findIndex(
        (val) => val.conditionName === "sinusitis"
      );
      const otitisIndex = reAssessConditions.findIndex(
        (val) => val.conditionName === "otitis media"
      );

      if (sinusitisIndex >= 0) {
        conditionsToReturn.push(reAssessConditions[sinusitisIndex]);
      }
      if (otitisIndex >= 0) {
        conditionsToReturn.push(reAssessConditions[otitisIndex]);
      }
    } else {
      const asthmaIndex = reAssessConditions.findIndex(
        (val) => val.conditionName === "asthma"
      );
      const hypothyroidismIndex = reAssessConditions.findIndex(
        (val) => val.conditionName === "hypothyroidism"
      );

      if (asthmaIndex >= 0) {
        conditionsToReturn.push(reAssessConditions[asthmaIndex]);
      }
      if (hypothyroidismIndex >= 0) {
        conditionsToReturn.push(reAssessConditions[hypothyroidismIndex]);
      }
    }

    return conditionsToReturn;
  };

  const handleChronic = () => {
    if (
      chronicMCVals.includes("asthma") &&
      chronicMCVals.includes("hypothyroidism")
    ) {
      updateSelectedCondition("asthma");
      setMedicationStepCount(1);
      setIsAcuteCreation(false);
      setShowMCCreateSlider(true);
    } else if (chronicMCVals.includes("asthma")) {
      setMedicationStepCount(null);
      updateSelectedCondition("asthma");

      // checking for Thyroid, If present then show alert first and then create slider for Asthma
      const isThryoidExist = medicalConditions.some(
        (val) =>
          val.status === "active" &&
          val.conditionName.includes("hypothyroidism")
      );
      if (isThryoidExist) {
        // filtering out options to show in alert pop-up
        const filterConditions = medicalConditions.filter(
          (c) =>
            c.status === "active" &&
            chronicMCEnum.options.some(
              (o) =>
                !o.value.includes("asthma") &&
                o.value.toLowerCase() === c.conditionName.toLowerCase()
            )
        );
        if (filterConditions.length > 0) {
          setReAssessConditions(filterConditions);
          setOpenMCAlertDialog(true);
          setNeedToOpenMCCreateAfterAlert(true);
        }
      } else {
        // setting field to open create slider
        setMedicationStepCount(null);
        updateSelectedCondition("asthma");
        setIsAcuteCreation(false);
        setShowMCCreateSlider(true);
      }
    } else if (chronicMCVals.includes("hypothyroidism")) {
      setMedicationStepCount(null);
      updateSelectedCondition("hypothyroidism");

      // checking for asthama, If present then show alert first and then create slider for thyroid
      const isAsthmaExists = medicalConditions.some(
        (val) => val.status === "active" && val.conditionName.includes("asthma")
      );
      if (isAsthmaExists) {
        // filtering out options to show in alert pop-up
        const filterConditions = medicalConditions.filter(
          (c) =>
            c.status === "active" &&
            chronicMCEnum.options.some(
              (o) =>
                !o.value.includes("hypothyroidism") &&
                o.value.toLowerCase() === c.conditionName.toLowerCase()
            )
        );
        if (filterConditions.length > 0) {
          setReAssessConditions(filterConditions);
          setOpenMCAlertDialog(true);
          setNeedToOpenMCCreateAfterAlert(true);
        }
      } else {
        // setting field to open create slider
        setMedicationStepCount(null);
        updateSelectedCondition("hypothyroidism");
        setIsAcuteCreation(false);
        setShowMCCreateSlider(true);
      }
    } else {
      const filterConditions = medicalConditions.filter(
        (c) =>
          c.status === "active" &&
          chronicMCEnum.options.some(
            (o) => o.value.toLowerCase() === c.conditionName.toLowerCase()
          )
      );
      if (filterConditions.length > 0) {
        setReAssessConditions(filterConditions);
        setOpenMCAlertDialog(true);
      } else {
        setRedFlagCard(3);
      }
    }
  };

  //Red Flag Model Outputs
  const onSkipOrSaveMedicalCondition = () => {
    if (medicationStepCount === 1) {
      const nextCondition =
        RedFlagCard === 1 ? "otitis media" : "hypothyroidism";
      setShowMCCreateSlider(false);
      if (sliderTransitionTimeoutRef.current) {
        clearTimeout(sliderTransitionTimeoutRef.current);
      }
      sliderTransitionTimeoutRef.current = setTimeout(() => {
        updateSelectedCondition(nextCondition);
        setMedicationStepCount(2);
        setShowMCCreateSlider(true);
      }, sliderTransitionMs);
      return;
    }
    if (medicationStepCount === 2 || medicationStepCount === null) {
      setShowMCCreateSlider(false);
      if (RedFlagCard === 1) {
        setRedFlagCard(2);
      } else if (RedFlagCard === 2) {
        setRedFlagCard(3);
      }
    }
  };

  const handleAlerts = () => {
    const isOtitis = acuteMCVals.includes("otitis media");
    const isRecurrent = acuteMCVals.includes("sinusitis");
    const isAsthma = chronicMCVals.includes("asthma");
    const isThyroid = chronicMCVals.includes("hypothyroidism");
    // const controlledAsthma = isAsthma ? asthmaSymptomControl : true;
    // const controlledThyroid = isThyroid ? thyroidSymptomControl : true;

    const noRedFlag =
      !isOtitis &&
      !isRecurrent &&
      (!isAsthma || (isAsthma && asthmaSymptomControl)) &&
      (!isThyroid || (isThyroid && thyroidSymptomControl));
    if (!continueService) {
      if (noRedFlag) {
        setOpenNoMCDialog(true);
      } else {
        var message = <></>;
        if (
          isOtitis &&
          !isRecurrent &&
          (!isAsthma || (isAsthma && asthmaSymptomControl)) &&
          (!isThyroid || (isThyroid && thyroidSymptomControl))
        )
          message = <>Otitis Media (chronic ear infections)</>;
        else if (
          !isOtitis &&
          isRecurrent &&
          (!isAsthma || (isAsthma && asthmaSymptomControl)) &&
          (!isThyroid || (isThyroid && thyroidSymptomControl))
        )
          message = <>Chronic Sinusitis</>;
        else if (
          !isOtitis &&
          !isRecurrent &&
          isAsthma &&
          !asthmaSymptomControl &&
          (!isThyroid || (isThyroid && thyroidSymptomControl))
        )
          message = <>Uncontrolled Asthma</>;
        else if (
          !isOtitis &&
          !isRecurrent &&
          (!isAsthma || (isAsthma && asthmaSymptomControl)) &&
          isThyroid &&
          !thyroidSymptomControl
        )
          message = <>Uncontrolled Thyroid</>;
        else {
          message = (
            <ul class="pl-4 list-disc">
              {isAsthma && !asthmaSymptomControl ? (
                <li>Uncontrolled Asthma</li>
              ) : null}
              {isThyroid && !thyroidSymptomControl ? (
                <li>Uncontrolled Thyroid</li>
              ) : null}
              {isRecurrent ? (
                <li>Recurrent or Chronic Sinusitis</li>
              ) : null}
              {isOtitis ? (
                <li>Otitis Media (chronic ear infections)</li>
              ) : null}
            </ul>
          );
        }

        setAlterContent(
          <>
            <p className="text-base font-semibold text-gray-600">{message}</p>
            {/* <br /> */} {/* commented out to remove extra space */}
          </>
        );
        setOpenMultiConditionDialog(true);
      }
    }
  };

  const convertSymptomControlToBoolean = (val) => {
    if (val === "controlled" || val === true) return true;
    if (val === "not controlled" || val === false) return false;
    return null;
  };

  const updateSymptomControl = (condition, val) => {
    const booleanValue = convertSymptomControlToBoolean(val);
    if (condition === "asthma") setAsthmaSymptomControl(booleanValue);
    else if (condition === "hypothyroidism") setThyroidSymptomControl(booleanValue);
  };

  const handleAlertConfirmation = (conditionsToKeep) => {
    let showCreateAfterAlert = false;
    let isAcuteRequest = false;
    if (conditionsToKeep && conditionsToKeep.length > 0) {
      const isAcute = acuteMCEnum.options.some(
        (v) => v.value === conditionsToKeep[0].conditionName
      );
      isAcuteRequest = isAcute;
      if (isAcute) {
        let acuteValue = [...acuteMCVals];
        if (acuteMCVals.includes("None")) {
          acuteValue = conditionsToKeep.map((val) => val.conditionName);
        } else {
          conditionsToKeep.forEach((cond) => {
            if (!acuteValue.includes(cond.conditionName)) {
              acuteValue.push(cond.conditionName);
            }
          });
        }

        // To work with both condition.
        if (acuteValue.length > 1) {
          updateSelectedCondition("sinusitis");
          setMedicationStepCount(1);
        } else {
          updateSelectedCondition(acuteValue[0]);
        }

        showCreateAfterAlert = acuteValue.length > 0;

        setAcuteMCVals(acuteValue);
        setRedFlagObj({
          ...redFlagObj,
          acuteMCVals: acuteValue,
        });
      } else {
        let chronicValue = [...chronicMCVals];
        if (chronicMCVals.includes("None")) {
          chronicValue = conditionsToKeep.map((val) => val.conditionName);
        } else {
          conditionsToKeep.forEach((cond) => {
            if (!chronicValue.includes(cond.conditionName)) {
              chronicValue.push(cond.conditionName);
            }
          });
        }

        // To work with both condition.
        if (chronicValue.length > 1) {
          updateSelectedCondition("asthma");
          setMedicationStepCount(1);
        } else {
          updateSelectedCondition(chronicValue[0]);
        }

        showCreateAfterAlert = chronicValue.length > 0;
        setChronicMCVals(chronicValue);
        setRedFlagObj({
          ...redFlagObj,
          chronicMCVals: chronicValue,
        });
      }
    }
    dispatch(fetchMedicalConditions(patientId));
    setOpenMCAlertDialog(false);
    if (needToOpenMCCreateAfterAlert || showCreateAfterAlert) {
      setShowMCCreateSlider(true);
      if (isAcuteRequest) {
        setIsAcuteCreation(true);
      } else {
        setIsAcuteCreation(false);
      }
    } else {
      if (RedFlagCard === 1) setRedFlagCard(2);
      else {
        setRedFlagCard(3);
      }
    }
  };

  // const conditionAlertConfirmation = (updatedConditions) => {
  //   let openChronicSlider = 0;
  //   let acuteValue = [...acuteMCVals];
  //   let chronicValue = [...chronicMCVals];
  //   const isAcute = acuteMCEnum.options.some(
  //     (v) => v.value === updatedConditions[0]?.conditionName
  //   );
  //   dispatch(fetchMedicalConditions(patientId));
  //   updatedConditions.forEach((cond) => {
  //     if (isAcute) {
  //       if (cond.isKeep) {
  //         if (acuteMCVals.includes("None")) {
  //           acuteValue = [...acuteValue, cond.conditionName];
  //         } else {
  //           if (!acuteMCVals.includes(cond.conditionName)) {
  //             acuteValue.push(cond.conditionName);
  //           }
  //         }
  //       } else {
  //         if (acuteMCVals.includes(cond.conditionName)) {
  //           acuteValue = acuteMCVals.filter((x) => x !== cond.conditionName);
  //         }
  //       }
  //       setAcuteMCVals(acuteValue.length > 0 ? acuteValue : ["None"]);
  //       setRedFlagObj({
  //         ...redFlagObj,
  //         acuteMCVals: acuteValue,
  //       });
  //       //isDeleted
  //     } else {
  //       if (cond.isKeep) {
  //         if (chronicMCVals.includes("None")) {
  //           chronicValue = [...chronicValue, cond.conditionName];
  //         } else {
  //           if (!chronicValue.includes(cond.conditionName)) {
  //             chronicValue.push(cond.conditionName);
  //           }
  //         }
  //         setIsAcuteCreation(false);
  //         updateSelectedCondition(cond?.conditionName);
  //         openChronicSlider = openChronicSlider + 1;
  //       } else {
  //         if (chronicMCVals.includes(cond.conditionName)) {
  //           chronicValue = chronicValue.filter(
  //             (x) => x !== cond.conditionName
  //           );
  //         }
  //       }
  //       setChronicMCVals(chronicValue.length > 0 ? chronicValue : ["None"]);
  //       setRedFlagObj({
  //         ...redFlagObj,
  //         chronicMCVals: chronicValue,
  //       });
  //     }
  //   });

  //   setOpenMCAlertDialog(false);
  //   if (openChronicSlider === 1) {
  //     setReConfirmingTheControl(true);
  //     setShowMCCreateSliderStep(null);
  //     setShowMCCreateSlider(true);
  //   } else if (openChronicSlider > 1) {
  //     setReConfirmingTheControl(true);
  //     setShowMCCreateSliderStep(1);
  //     updateSelectedCondition(updatedConditions[0]?.conditionName);
  //     setShowMCCreateSlider(true);
  //   }
  // };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Red Flag Medical Conditions
                </h4>

                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div
                className="grid grid-flow-col auto-cols-[480px] gap-6 scroll-smooth overflow-auto"
                id="life-style"
              >
                {/* acuteMC */}
                <div
                  className={`${RedFlagCard != 1 ? "pointer-events-none" : ""}`}
                >
                  <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                    <div
                      className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                      style={{
                        backgroundImage: `url(/icons/texture-background-2.png)`,
                      }}
                    >
                      <h3 className="text-xl font-bold text-teal-600 ">
                        Acute Medical Conditions
                      </h3>
                    </div>
                    <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                      <div className="flex flex-col gap-4">
                        <p className="text-lg h-[51px] font-semibold text-gray-800">
                          {acuteMCEnum.question}
                          <br />
                          <span className="font-normal">
                            {acuteMCEnum.subquestion}{" "}
                          </span>
                        </p>
                        <div className="flex flex-col gap-2">
                          {acuteMCEnum.options.map((option) => {
                            return (
                              <>
                                <button
                                key={option.value}
                                  onClick={() => {
                                    acuteMultiSelection(option.value);
                                  }}
                                  className={`"font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600" ${
                                      acuteMCVals?.includes(option.value)
                                        ? "bg-gray-20 border-gray-600"
                                        : "bg-white border-gray-100"
                                  }`}
                                >
                                  <p className="font-semibold text-body-md flex flex-row gap-2 justify-start items-start">
                                    {option.header}{" "}
                                    {option.value === "otitis media" && (
                                      <span>
                                        <ReactSVG
                                          src="/icons/information-dark.svg"
                                          className="w-5"
                                          data-tooltip-id="otitis-tip"
                                        />
                                        <NewToolTip
                                          id="otitis-tip"
                                          render={() => <OtitisCond />}
                                        />
                                      </span>
                                    )}
                                    {option.value === "sinusitis" && (
                                      <span>
                                        <ReactSVG
                                          src="/icons/information-dark.svg"
                                          className="w-5"
                                          data-tooltip-id="recurrent-tip"
                                        />
                                        <NewToolTip
                                          id="recurrent-tip"
                                          render={() => <RecurrentCond />}
                                        />
                                      </span>
                                    )}
                                  </p>
                                  <p className="font-semibold text-gray-600 text-body-md flex justify-start items-start">
                                    {option.subHeader}
                                  </p>
                                </button>
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    {RedFlagCard === 1 && (
                      <div
                        className={`flex gap-10 p-[10px] px-1 py-1 bg-gray-20 justify-end`}
                      >
                        <button
                          className="disabled:opacity-40 m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200  text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                          onClick={() => {
                            setRedFlagObj({
                              ...redFlagObj,
                              acuteMCVals: acuteMCVals,
                            });
                            handleAcute();
                            setIsAcuteMCUpdate(false);
                          }}
                          disabled={acuteMCVals?.length == 0}
                        >
                          {/* <h3 className="text-body-md font-semibold text-white">
                            {isAcuteMCUpdate ? "Save & Continue" : "Continue"}
                          </h3> */}
                          <ChevronRightIcon className="w-4 h-4 text-white" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                {/* chronicMC */}
                <div
                  className={`${RedFlagCard === 1 ? "opacity-40" : ""} ${
                    RedFlagCard != 2 ? "pointer-events-none" : ""
                  }`}
                >
                  <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                    <div
                      className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                      style={{
                        backgroundImage: `url(/icons/texture-background-2.png)`,
                      }}
                    >
                      <h3 className="text-xl font-bold text-teal-600 ">
                        Chronic Medical Conditions
                      </h3>
                    </div>
                    <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                      <div className="flex flex-col gap-4">
                        <p className="text-lg h-[51px] font-semibold text-gray-800">
                          {chronicMCEnum.question}
                          <br />
                          <span className="font-normal">
                            {chronicMCEnum.subquestion}{" "}
                          </span>
                        </p>
                        <div className="flex flex-col gap-2">
                          {chronicMCEnum.options.map((option) => {
                            return (
                              <>
                                <button
                                key={option.value}
                                  onClick={() =>
                                    chronicMultiSelection(option.value)
                                  }
                                  className={`"font-semibold text-body-md p-3 rounded-[4px] border-[1px]
                                    text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600" ${
                                      chronicMCVals?.includes(option.value)
                                        ? "bg-gray-20 border-gray-600"
                                        : "bg-white border-gray-100"
                                  }`}
                                >
                                  <p className="font-semibold text-body-md flex gap-2 justify-start items-start">
                                    {option.header}
                                  </p>
                                  <p className="font-semibold text-gray-600 text-body-md flex justify-start items-start">
                                    {option.subHeader}
                                  </p>
                                </button>
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    {RedFlagCard === 2 && (
                      <div
                        className={`flex gap-10 p-[10px] px-1 py-1 bg-gray-20 justify-between`}
                      >
                        <button
                          className="m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200  text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                          onClick={() => {
                            setRedFlagCard(1);
                          }}
                        >
                          <ChevronLeftIcon className="w-4 h-4 text-white" />
                        </button>
                        <button
                          className="disabled:opacity-40 m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200  text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                          onClick={() => {
                            setRedFlagObj({
                              ...redFlagObj,
                              chronicMCVals: chronicMCVals,
                            });
                            setIsChronicMCUpdate(false);
                            handleChronic();
                          }}
                          disabled={chronicMCVals?.length === 0}
                        >
                          {/* <h3 className="text-body-md font-semibold text-white">
                            {isChronicMCUpdate ? "Save & Continue" : "Continue"}
                          </h3> */}
                          <ChevronRightIcon className="w-4 h-4 text-white" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                {/* Clinical Analysis */}
                {RedFlagCard === 3 && (
                  <div>
                    <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div className="flex flex-row justify-start rounded-s">
                        <button
                          className="m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200  text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                          onClick={() => {
                            setRedFlagCard(2);
                            setCompleteSubStep(false);
                            setClinicalAnalysis(false);
                            setContinueService(false);
                          }}
                        >
                          <ChevronLeftIcon className="w-4 h-4 text-white" />
                        </button>
                      </div>
                      <div className="m-8 h-[420px] w-[420px] bg-blue-100 rounded-full flex items-center justify-center bg-opacity-40">
                        <ReactSVG
                          src={"/icons/analysis-pad.svg"}
                          className={``}
                        />
                      </div>
                      <div className="mx-7 my-5">
                        {!clinicalAnalysis && (
                          <Button
                            className="w-full !px-2 !text-xl"
                            type="primary"
                            text="Red Flag Results"
                            onClick={() => {
                              handleAlerts();
                            }}
                          />
                        )}
                        {clinicalAnalysis && (
                          <h4 className="text-xl text-REELTeal font-bold items-center justify-center flex">
                            Red Flag Review Complete
                          </h4>
                        )}
                        {/* <Button
                            className="w-full"
                            type="primary"
                            text="Go Back For Testing"
                            onClick={() => {
                              setRedFlagCard(2);
                              setClinicalAnalysis(false);
                              setCompleteSubStep(false);
                            }}
                          /> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Red Flag Medical Condition Alerts */}
            <EndServiceModel
              open={openNoMCDialog}
              showEndServiceAndRef={false}
              showOTCConsultAndRef={false}
              className="w-[40%]"
              title="Red Flag Medical Conditions Alert"
              content={() => <p>No Red Flag Conditions Identified</p>}
              handleClose={() => {
                setContinueService(false);
                setOpenNoMCDialog(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref) => {
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                setOpenNoMCDialog(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setIsContinueClicked(true);
                setContinueService(true);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
            />
            <EndServiceModel
              open={openMultiConditionDialog}
              title="Red Flag Medical Conditions Alert"
              content={() => alterContent}
              handleClose={() => {
                setContinueService(false);
                setOpenMultiConditionDialog(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref, exp) => {
                setAlertConfirmation(
                  ref
                    ? AlertConfirmationTypes.ContinueWithRefer
                    : AlertConfirmationTypes.ContinueWithNoReferral
                );
                setAlertExplaination(exp);
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                setOpenMultiConditionDialog(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setIsContinueClicked(true);
                setContinueService(true);
                updateStepsVisibility(false);
              }}
              handleEndService={() => {
                setShowRef(true);
                setAlertConfirmation(AlertConfirmationTypes.EndService);
                setAlertExplaination("");
                setOpenMultiConditionDialog(false);
                updateStepsVisibility(true);
                setClickedEndService(true);
              }}
            />
            <MedicalConditionAlert
              open={openMCAlertDialog}
              title="Medical Condition Alert"
              type="primary"
              cancelBtnType="primary-outline"
              confirmText="Save & Continue"
              cancelText="Cancel"
              className="text-gray-800 !w-[630px] !min-w-[630px]"
              reAssessConditions={getSortedConditions()}
              patientId={patientId}
              onCross={() => setOpenMCAlertDialog(false)}
              handleClose={() => setOpenMCAlertDialog(false)}
              confirmAction={(conditionsToKeep) => {
                handleAlertConfirmation(conditionsToKeep);
              }}
            />

            {/* Red Flag Medical Condition Models */}
            <MedicalConditionCreate
              isAcuteCreation={isAcuteCreation}
              create={
                !medicalConditions?.some(
                  (i) =>
                    i.status === "active" &&
                    i.conditionName === selectedMedicalCondition?.value
                )
              }
              selectedCondition={
                medicalConditions?.filter(
                  (i) => i.conditionName === selectedMedicalCondition?.value
                )[0]
              }
              updateSymptomControl={updateSymptomControl}
              open={showMCCreateSlider}
              step={medicationStepCount}
              conditionOption={selectedMedicalCondition}
              patientMedicalConditions={medicalConditions}
              patientId={patientId}
              onClose={(value) => {
                setShowMCCreateSlider(value);
              }}
              onSkip={() => {
                onSkipOrSaveMedicalCondition();
              }}
              onSave={() => {
                setTimeout(() => {
                  dispatch(fetchMedicalConditions(patientId));
                }, 500);
                onSkipOrSaveMedicalCondition();
              }}
              fromClinicalService={true}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] ${
              !completeSubStep && "opacity-40 pointer-events-none"
            }`}
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RedFlag;
